export const CABINET_SKU = {
  BASE_SPACER: -1,
  WALL_SPACER: -2,
  VOID_SPACE: -3
};

/**
 * ID for the custom spacer type (user-defined dimensions)
 */
export const CUSTOM_SPACER_TYPE_ID = 'custom_spacer';

/**
 * Base URL for blinds media - used to detect invalid/placeholder spacer images
 */
export const BASE_BLINDS_MEDIA_URL = 'https://blinds.homedepot.com/';

/**
 * Check if a SKU is a spacer (base or wall)
 * @param {number} sku - The cabinet SKU
 * @returns {boolean} True if the SKU is a spacer
 */
export const isSpacerSku = (sku) => sku === CABINET_SKU.BASE_SPACER || sku === CABINET_SKU.WALL_SPACER;

export const DIRECTION = {
  LEFT: 'left',
  RIGHT: 'right'
};
